import React from "react";
import { motion } from "framer-motion";
import Slider from "react-slick";
// import img from '../../assets/m11.webp'

// Hero & right content images
import heroImg from "../../assets/9.jpg";
import contentImg from "../../assets/It.jpg";

// ✅ Local project images it11.jpg se it66.jpg
import img1 from "../../assets/it11.webp";
import img2 from "../../assets/it22.webp";
import img3 from "../../assets/it33.webp";
import img4 from "../../assets/it44.webp";
import img5 from "../../assets/it55.webp";
import img6 from "../../assets/it66.webp";

const projectImages = [img1, img2, img3, img4, img5, img6];

const ItPark = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 640, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="w-full">
      {/* Hero Section */}
      <div
        className="w-full h-[430px] relative flex items-center justify-start px-6 md:px-12"
        style={{
          backgroundImage: `url(${heroImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="absolute inset-0 bg-black/40" />
        <motion.div
          className="relative p-4 md:p-6 rounded-md"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <p className="text-white text-sm md:text-base mb-1 cursor-pointer">Home</p>
          <h1 className="text-white text-2xl md:text-4xl font-bold">IT PARK LIFTS</h1>
        </motion.div>
      </div>

      {/* Content Section */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 flex flex-col md:flex-row items-center gap-10">
        {/* Left Content */}
        <motion.div
          className="md:w-1/2 space-y-6"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: { opacity: 0, x: 80 },
            visible: { opacity: 1, x: 0, transition: { duration: 1 } },
          }}
        >
          <motion.p className="text-gray-700 text-lg leading-relaxed text-justify">
            IT parks typically accommodate multiple IT companies, making lifts an 
            essential feature for efficient transportation of employees, visitors, 
            and service personnel across various floors.
          </motion.p>
          <motion.p className="text-gray-700 text-lg leading-relaxed text-justify">
            Designed to manage high foot traffic during peak hours, lifts in IT parks 
            ensure swift and seamless movement. They are equipped with advanced safety 
            features, including emergency stop buttons, automatic doors, and sensors to 
            detect obstructions, ensuring the safety of all users.
          </motion.p>
          <motion.p className="text-gray-700 text-lg leading-relaxed text-justify">
            Key considerations for lift design in IT parks include minimizing waiting 
            times, optimizing capacity, and strategic placement within the building. 
            Additionally, energy-efficient lifts are vital to reducing the building’s 
            carbon footprint.
          </motion.p>
          <motion.p className="text-gray-700 text-lg leading-relaxed text-justify">
            Johnson Lifts integrates cutting-edge technology to enhance efficiency and 
            reduce waiting times. The innovative Destination Control System (DCS) enables 
            employees to pre-book lifts from a distance, allowing them to access their 
            designated lift with minimal waiting or confusion upon reaching the lobby.
          </motion.p>
        </motion.div>

        {/* Right Image */}
        <motion.div
          className="md:w-1/2 w-full overflow-hidden rounded-2xl shadow-2xl"
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <img
            src={contentImg}
            alt="IT Park Lift"
            className="w-full h-[350px] md:h-[400px] object-cover rounded-2xl"
          />
        </motion.div>
      </div>

      {/* Projects Section */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-10"
          initial={{ opacity: 0, y: -80 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          SOME PROJECTS
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, y: -120 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >
          <Slider {...sliderSettings}>
            {projectImages.map((img, idx) => (
              <motion.div
                key={idx}
                className="px-2"
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: idx * 0.1 }}
              >
                <img
                  src={img}
                  alt={`Project ${idx + 1}`}
                  className="w-full h-64 md:h-72 object-cover rounded-2xl shadow-lg"
                />
              </motion.div>
            ))}
          </Slider>
        </motion.div>
      </div>
    </div>
  );
};

export default ItPark;
